import React from 'react';
import {Helmet} from "react-helmet";
import API from "../../api";
import "../../assets/css/notification.css";
import "../../assets/css/input.css";
import "../../assets/css/errors.css";
const api = new API();
import {withSnackbar} from "notistack";
import {validateEmail, hideAlertAfterDelay} from "../../helper";
import '../../assets/css/errors.css';
import {instanceOf} from "prop-types";
import {Cookies, withCookies} from "react-cookie";
import 'react-phone-number-input/style.css'
import {NavLink} from "react-router-dom";

class Forgot extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            errorAlert: false,
            successAlert : false,
            res_message : null,
            errors: {},
            emailTouched: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleEmailBlur = this.handleEmailBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.alertBox = React.createRef();
    }

    componentDidMount() {
        if (this.props.cookies.get('token') && this.props.cookies.get('token') !== undefined && this.props.cookies.get('token') !== "") {
            this.props.history.push('/');
        }
        if (this.props.cookies.get('toggle') && this.props.cookies.get('toggle') !== undefined && this.props.cookies.get('toggle') === "toggled") {
            this.props.cookies.set('toggle', "");
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.cookies.get('toggle') && this.props.cookies.get('toggle') !== undefined && this.props.cookies.get('toggle') === "toggled") {
            this.props.cookies.set('toggle', "");
        }
    }

    getEmailValidationError(email) {
        return !email || !validateEmail(email) ? "Enter valid email address" : "";
    }

    getEmailErrors(emailError) {
        return emailError ? {email: emailError} : {};
    }

    handleChange(event) {
        const email = event.target.value;
        // Keep initial typing quiet; after blur/submit, validate on change so visible errors clear immediately.
        const emailError = this.state.emailTouched ? this.getEmailValidationError(email) : "";

        this.setState({
            email,
            res_message: null,
            errorAlert: false,
            successAlert: false,
            errors: this.getEmailErrors(emailError),
        });
    }

    handleEmailBlur() {
        const emailError = this.getEmailValidationError(this.state.email);

        this.setState({
            emailTouched: true,
            errors: this.getEmailErrors(emailError),
        });
    }

    handleSubmit(event) {

        event.preventDefault();

        const emailError = this.getEmailValidationError(this.state.email);

        if (emailError) {
            this.setState({emailTouched: true, errors: this.getEmailErrors(emailError)});
            return false;
        }

        api.forgot({email: this.state.email}, 'blank').then(success => {

            if (success.data.status == "400") {
                this.setState({
                    res_message : success.data.message,
                    errorAlert: true
                });
                return false;
            }
            this.setState({email: '', successAlert: true, errors: {}, emailTouched: false});

            // clear previous timer
            if (this.alertTimeout) {
                clearTimeout(this.alertTimeout);
            }
        
            // start new timer
            this.alertTimeout = hideAlertAfterDelay(() => {
                this.setState({ errorAlert: null, successAlert: null});
            });
        }).catch(error => {
            this.setState({
                res_message : error.response.data.message,
                errorAlert: true
            });

            // clear previous timer
            if (this.alertTimeout) {
                clearTimeout(this.alertTimeout);
            }
        
            // start new timer
            this.alertTimeout = hideAlertAfterDelay(() => {
                this.setState({ errorAlert: null });
            });
        });
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>
                        Forgot Password - Farmer&#039;s Fresh Meat: Houston Meat Market
                        &amp; Butcher Shop
                    </title>
                </Helmet>

                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-9 col-lg-7 col-xl-6 mx-auto">
                            <div className="bg-white border-1 main-section p-3 p-md-5">
                            <div className="signin-info text-center mt-0">
                                <h1 className="mb-2">Forgot Password</h1>
                                <p className="font-weight-normal mb-2">Forgot your password? No problem, just tell us the email associated with your
                                    account, and we’ll email a link to reset your password.</p>
                            </div>

                            {this.state.successAlert ? (
                                <div className="col-12 px-4">
                                    <div ref={this.alertBox}
                                        role="alert"
                                        className="sc-1wz9i2x-0 fooVeKSuccess align-items-start mt-1"
                                    >
                                        <svg viewBox="0 0 512 512" className="text-success w-16 mr-2">
                                            <path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z"/>
                                        </svg>
                                        <div className="text-message">
                                            <h6>Password reset link sent.</h6>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {this.state.errorAlert ? (
                                <div className="col-12 px-4">
                                    <div ref={this.alertBox}
                                         role="alert"
                                         className="sc-1wz9i2x-0 fooVeK align-items-start mt-1"
                                    >
                                        <svg
                                            width="1792"
                                            height="1792"
                                            viewBox="0 0 1792 1792"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            className="sc-1t1e23j-0 bbiirI"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M1024 1375v-190q0-14-9.5-23.5T992 1152H800q-13 0-22.5 9.5T768 1185v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11H786q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17H128q-34 0-63.5-17T18 1601q-37-63-2-126L784 67q17-31 47-49t65-18 65 18 47 49z"
                                            ></path>
                                        </svg>
                                        <div className="text-message">
                                            <h6>{this.state.res_message}</h6>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                                <form>
                                    <div className="row">
                                        <div className="form-group col-12">
                                            <input
                                                type="email"
                                                className={
                                                    "form-control valid-control " +
                                                    (this.state.errors?.email ? "invalid" : "")
                                                }
                                                id="email"
                                                name="email"
                                                placeholder="Email*"
                                                value={this.state.email}
                                                onChange={this.handleChange}
                                                onBlur={this.handleEmailBlur}
                                            />
                                            <span className="error-text mt-1 mb-1">
                                            {this.state.errors?.email}
                                        </span>
                                        </div>
                                        <div
                                            className="update-btn col-12"
                                            onClick={this.handleSubmit}
                                        >
                                            <a
                                                href="#"
                                                className="btn btn-cart w-100"
                                            >
                                                Send Email
                                            </a>
                                        </div>
                                    </div>

                                </form>

                        </div>
                    </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withCookies(withSnackbar(Forgot));
